import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styles from './Badge.module.css';
export const Badge = ({ children, variant = 'default', size = 'md', rounded = false, outline = false, icon, className, 'data-testid': testId, }) => {
    const badgeClasses = [
        styles.badge,
        styles[variant],
        styles[size],
        rounded && styles.rounded,
        outline && styles.outline,
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("span", { className: badgeClasses, "data-testid": testId, children: [icon && _jsx("span", { className: styles.icon, children: icon }), _jsx("span", { className: styles.content, children: children })] }));
};
export default Badge;
